import ScrollReveal from 'scrollreveal';

export default function scrollReveal() {
  const sr = new ScrollReveal({
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: 0,
    scale: 1,
    mobile: true,
    reset: false,
    useDelay: 'once',
    origin: 'bottom',
    duration: 800,
    distance: '12px',
    delay: 125,
    viewFactor: 0, //percentage of element that has to be in screen before reveal, 0 to 1
    afterReveal: function (el) {
      $(el).addClass('revealed');
    },
    beforeReveal: function (el) {
      $(el).addClass('reveal-started');
    },
  });

  function reveal(selector, options, sequenceInterval) {
    $(selector).each(function () {
      if (!$(this).closest('.modal-body').length) {
        sr.reveal(this, options, sequenceInterval);
      }
    });
  }

  /**
   * Group
   */
  reveal('.main > .wp-block-group', {
    distance: 0,
  });
  reveal('.main > .wp-block-group > .wp-block-group__inner-container', {
    distance: '20px',
  });

  /**
   * Columns
   */
  reveal('.wp-block-group__inner-container > .wp-block-columns', {
    distance: '20px',
  });

  /**
   * Cover block
   */
  reveal('.wp-block-cover', {
    distance: 0,
    scale: 1.15,
    duration: 1500,
  });

  reveal('.wp-block-cover__inner-container', {
    distance: '45px',
  });

  /**
   * Habitations block
   */
  reveal('.block.habitations', {
    distance: 0,
  });

  reveal('.habitations__habitation__link', {
    distance: 0,
    scale: 1.15,
    duration: 1500,
  });

  /**
   * Image block
   */
  reveal('.wp-block-image img', {
    distance: 0,
    scale: 1.15,
    duration: 1500,
  });

  /**
   * Units images
   */
  reveal('.units__images__inner', {
    distance: 0,
    scale: 1.15,
    duration: 1500,
  });

  /**
   * Units form and results
   */
  reveal('.units__type');

  /**
   * Gallery
   */
  reveal('.wp-block-gallery', {
    distance: 0,
  });

  /**
   * Map
   */
  reveal('.block.map, .map__map', {
    distance: 0,
  });

  reveal('.map__hover', {
    distance: '20px',
  });

  /**
   * Add class when all images have been revealed
   */
  $('.main > .wp-block-group').each(function () {
    const $section = $(this);
    const $checkRevealed = $(this).find('.wp-block-gallery, .wp-block-image img');
    if (!$checkRevealed.length) {
      $section.addClass('images-revealed');
      return;
    }
    const loop = setInterval(function () {
      let allRevealed = true;
      $checkRevealed.each(function () {
        if (!$(this).hasClass('reveal-started')) {
          allRevealed = false;
        }
      });
      if (allRevealed) {
        $section.addClass('images-revealed');
        clearInterval(loop);
      }
    }, 50);
  });

  /**
   * Footer
   */
  reveal('.footer', {
    distance: 0,
  });
  reveal('.footer__container', {
    distance: '20px',
  });
}
